import ApplicationSerializer from 'eflex/serializers/application';

export default class JemContainmentSerializer extends ApplicationSerializer {
  attrs = {
    buildStatus: {
      embedded: 'always',
    },
  };
}
